'use es6';

const pageSettingsInfos = (availableConnectedDomainsCount, currentDomainName) => {
  const infos = {};
  if (availableConnectedDomainsCount > 1) {
    infos.multipleDomains = {
      pane: 'settings',
      type: 'multipleDomains',
      target: 'settings',
      message: 'pageSettings.publishButton.multipleDomains.info',
      data: {
        domainName: currentDomainName
      },
      useHtml: true
    };
  }
  return infos;
};
export default pageSettingsInfos;